module.exports = {
  "id": "06f5ce2e-a89e-4001-ad24-ad23af0ef699",
  "gtmIds": [
    "GTM-PX9TR478",
    "GTM-5MDK9ZL2"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "Caberfae Peaks",
  "language": "en-US",
  "defaultDateFormat": {
    "id": 8,
    "format": "MMM dd, yyyy",
    "name": "US Short With Year (Apr 23, 2026)"
  },
  "defaultNumberFormat": {
    "id": 1,
    "name": "English (Comma thousands, Dot decimals)",
    "format": "#,###.##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://caberfae-peaks-prod.spotliowebsites.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}